import { useState, useRef } from 'react';
import clsx from 'clsx';

import '@/administration/pages/ProductEditor/component/courseTeams.scss';
import { useOnClickOutside } from '@/hooks/useOnClickOutside';
import { Button } from '@/components/Button/Button';
import { ButtonList } from '@/components/Button/ButtonList';
import { RLearningJourneySessionDiscussionTeam, RLearningJourneySessionDiscussionTeamMember } from '@/store/v2';

type JourneyEditViewTeamsMemberRowProps = {
  teams: RLearningJourneySessionDiscussionTeam[];
  member: RLearningJourneySessionDiscussionTeamMember;
  teamIndex: number;
  onTeamSwitch: ({ newTeamId, oldTeamId, memberId }: { newTeamId: number; oldTeamId: number; memberId: number }) => void;
  teamId: number;
};

export const JourneyEditViewTeamsMemberRow = ({
  teams,
  member,
  teamIndex,
  onTeamSwitch,
  teamId,
}: JourneyEditViewTeamsMemberRowProps): React.ReactElement => {
  const [showMenu, setShowMenu] = useState(false);

  const node = useRef<HTMLDivElement>(null);

  useOnClickOutside(showMenu, setShowMenu, node);

  return (
    <label className={clsx('panel-block', 'member-block')}>
      <div>
        <div className="member-name">{member?.user?.username}</div>
        <span className="member-email">{member?.user?.email}</span>
      </div>
      <span className="member-realm">{member?.user?.realm}</span>
      <ButtonList ref={node} align="right">
        <div className={clsx('dropdown', 'is-right', showMenu && 'is-active')} onClick={() => setShowMenu(!showMenu)}>
          <div className="dropdown-trigger">
            <Button aria-haspopup="true" aria-controls="dropdown-menu" $icon="exchange-alt" />
          </div>
          <div className={clsx('dropdown-menu', 'team-menu')} id="dropdown-menu" role="menu">
            <div className="dropdown-content">
              {teams &&
                [...teams.values()].map(
                  (_team, optionIndex) =>
                    optionIndex !== teamIndex && (
                      <a
                        className="dropdown-item"
                        key={`${teamIndex}-${optionIndex}`}
                        onClick={() => {
                          setShowMenu(!showMenu);
                          onTeamSwitch({ newTeamId: _team?.id, oldTeamId: teamId, memberId: member?.user?.id });
                        }}
                      >
                        <span className="body1">{_team?.name}</span>
                      </a>
                    ),
                )}
            </div>
          </div>
        </div>
      </ButtonList>
    </label>
  );
};
